import { render, staticRenderFns } from "./AutomatedTasksTargetsDoc.vue?vue&type=template&id=70c48376"
import script from "./AutomatedTasksTargetsDoc.vue?vue&type=script&lang=js"
export * from "./AutomatedTasksTargetsDoc.vue?vue&type=script&lang=js"
import style0 from "./AutomatedTasksTargetsDoc.vue?vue&type=style&index=0&id=70c48376&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports